import React from 'react';
import classNames from 'classnames';
import { WALLET_STATUS } from 'constants/wallet';
import useTranslation from 'utils/hooks/useTranslation';
import { formatStatusDate } from 'pages/Wallet/helper';
import { getAvailableBalanceSubLineKey, isWalletInactive } from './helper';

import styles from './style.module.scss';

const AvailableBalance = ({
  balance,
  alertThreshold,
  status = WALLET_STATUS.active,
  statusChangedAt = null,
}) => {
  const { translateText } = useTranslation();
  const inactive = isWalletInactive(status);
  const statusDate = inactive ? formatStatusDate(statusChangedAt) : null;

  return (
    <div
      className={classNames(styles.statCard, { [styles.statCardInactive]: inactive })}
      data-testid="walletAvailableBalance"
    >
      <div className={styles.statHeader}>
        <span className={styles.statLabel}>
          {translateText('corporateAccounts.wallet.dashboard.availableBalance.label')}
        </span>
        <span
          className={classNames(styles.statChip, {
            [styles.statChipFrozen]: status === WALLET_STATUS.frozen,
            [styles.statChipClosed]: status === WALLET_STATUS.closed,
          })}
          data-testid="walletAvailableBalanceStatus"
        >
          {translateText(`corporateAccounts.common.status.${status}`)}
        </span>
      </div>
      <div className={styles.statValue}>{balance}</div>
      <div className={styles.statSub} data-testid="walletAvailableBalanceSubLine">
        {translateText(getAvailableBalanceSubLineKey(status, Boolean(statusDate)), {
          amount: alertThreshold,
          date: statusDate,
        })}
      </div>
    </div>
  );
};

export default AvailableBalance;
